var chunkMapping = {
	"0": [
		4645
	],
	"72": [
		5045
	],
	"148": [
		5121
	],
	"149": [
		5122
	],
	"152": [
		5125
	],
	"153": [
		5126
	],
	"154": [
		5127
	],
	"155": [
		5128
	],
	"156": [
		5129
	],
	"157": [
		5130
	],
	"158": [
		5131
	],
	"159": [
		5132
	],
	"160": [
		5133
	],
	"161": [
		5134
	],
	"162": [
		5135
	],
	"163": [
		5136
	],
	"164": [
		5137
	],
	"165": [
		5138
	],
	"166": [
		5139
	],
	"167": [
		5140
	],
	"168": [
		5141
	]
};
var idToExternalAndNameMapping = {
	"4645": [
		"default",
		"./Containers",
		3796
	],
	"5045": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5121": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5122": [
		"default",
		"./HostWrapper",
		3796
	],
	"5125": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5126": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5127": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5128": [
		"default",
		"./AuditDialog",
		3796
	],
	"5129": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5130": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5131": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5132": [
		"default",
		"./PaymentModal",
		3796
	],
	"5133": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5134": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5135": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5136": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5137": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5138": [
		"default",
		"./Challenge",
		3796
	],
	"5139": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5140": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5141": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4645": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5045": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5121": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5122": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}